import React from 'react';
import theme from '../../theme';
import { IconProps } from './props'

const ShareIcon: React.FC<IconProps> = ({ id, iconColor = theme.textDark, ...rest }) => (

	<svg
		width="40"
		height="41"
		viewBox="0 0 40 41"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		{...rest}
	>
		<path 
			fill-rule="evenodd"
			clip-rule="evenodd"
			fill={iconColor}
			d="M30.0007 5.15951C28.1597 5.15951 26.6673 6.65189 26.6673 8.49284C26.6673 10.3338 28.1597 11.8262 30.0007 11.8262C31.8416 11.8262 33.334 10.3338 33.334 8.49284C33.334 6.65189 31.8416 5.15951 30.0007 5.15951ZM23.334 8.49284C23.334 4.81094 26.3188 1.82617 30.0007 1.82617C33.6825 1.82617 36.6673 4.81094 36.6673 8.49284C36.6673 12.1747 33.6825 15.1595 30.0007 15.1595C26.3188 15.1595 23.334 12.1747 23.334 8.49284Z"
		/>
		<path 
			fill-rule="evenodd"
			clip-rule="evenodd"
			fill={iconColor}
			d="M10.0007 16.8255C8.1597 16.8255 6.66732 18.3179 6.66732 20.1589C6.66732 21.9998 8.1597 23.4922 10.0007 23.4922C11.8416 23.4922 13.334 21.9998 13.334 20.1589C13.334 18.3179 11.8416 16.8255 10.0007 16.8255ZM3.33398 20.1589C3.33398 16.477 6.31875 13.4922 10.0007 13.4922C13.6825 13.4922 16.6673 16.477 16.6673 20.1589C16.6673 23.8408 13.6825 26.8255 10.0007 26.8255C6.31875 26.8255 3.33398 23.8408 3.33398 20.1589Z"
		/>
		<path 
			fill-rule="evenodd"
			clip-rule="evenodd"
			fill={iconColor}
			d="M30.0007 28.4925C28.1597 28.4925 26.6673 29.9849 26.6673 31.8258C26.6673 33.6668 28.1597 35.1592 30.0007 35.1592C31.8416 35.1592 33.334 33.6668 33.334 31.8258C33.334 29.9849 31.8416 28.4925 30.0007 28.4925ZM23.334 31.8258C23.334 28.1439 26.3188 25.1592 30.0007 25.1592C33.6825 25.1592 36.6673 28.1439 36.6673 31.8258C36.6673 35.5077 33.6825 38.4925 30.0007 38.4925C26.3188 38.4925 23.334 35.5077 23.334 31.8258Z"
		/>
		<path 
			fill-rule="evenodd"
			clip-rule="evenodd"
			fill={iconColor}
			d="M12.8773 21.8366C13.3408 21.0413 14.3612 20.7723 15.1565 21.2357L26.5398 27.869C27.3351 28.3325 27.6041 29.3529 27.1407 30.1482C26.6772 30.9435 25.6568 31.2125 24.8615 30.7491L13.4782 24.1157C12.6829 23.6523 12.4139 22.6319 12.8773 21.8366Z"
		/>
		<path 
			fill-rule="evenodd"
			clip-rule="evenodd"
			fill={iconColor}
			d="M27.1235 10.1687C27.5874 10.9637 27.319 11.9843 26.524 12.4482L15.1574 19.0815C14.3624 19.5455 13.3418 19.2771 12.8778 18.4821C12.4139 17.6871 12.6823 16.6665 13.4773 16.2026L24.8439 9.56926C25.6389 9.10531 26.6595 9.37369 27.1235 10.1687Z"
		/>
	</svg>

);

export { ShareIcon };